import { render, staticRenderFns } from "./businessBox.vue?vue&type=template&id=320c313c&scoped=true"
import script from "./businessBox.vue?vue&type=script&lang=js"
export * from "./businessBox.vue?vue&type=script&lang=js"
import style0 from "./businessBox.vue?vue&type=style&index=0&id=320c313c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c313c",
  null
  
)

export default component.exports